import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

export function useAdvancedOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [latency, setLatency] = useState<number | null>(null)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const checkConnection = async () => {
      try {
        const start = Date.now()
        await fetch("https://www.google.com/favicon.ico", {
          method: "HEAD",
          mode: "no-cors",
          cache: "no-cache",
        })
        setLatency(Date.now() - start)
        setIsOnline(true)
      } catch {
        setIsOnline(false)
        setLatency(null)
      }

      // Check every 10 seconds
      timeoutId = setTimeout(checkConnection, 10000)
    }

    const handleOnline = () => checkConnection()
    const handleOffline = () => {
      setIsOnline(false)
      setLatency(null)
    }

    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)
    checkConnection()

    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])

  return { isOnline, latency }
}

export function AdvancedInternetStatusIndicator() {
  // const { isOnline, latency } = useAdvancedOnlineStatus();
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)

    return () => {
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])
  const [isVisible, setIsVisible] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    if (isOnline) {
      const timeoutId = setTimeout(() => {
        setIsVisible(false)
      }, 5000)
      return () => clearTimeout(timeoutId)
    } else {
      setIsVisible(true)
    }
  }, [isOnline])

  return (
    <motion.div
      className={`fixed bottom-0 right-4 p-3 shadow-md z-50 flex items-center gap-2 w-full h-3 text-center ${
        isOnline ? "bg-green-500" : "bg-red-500"
      } ${isVisible ? "" : "hidden"} text-white`}
      animate={isVisible ? { y: 0, opacity: 1 } : { y: "100%", opacity: 0 }}
      transition={{ type: "spring", damping: 20, stiffness: 300 }}
    >
      <div className="w-3 h-3 rounded-full animate-pulse" />
      <span
        className={`text-center ${
          isOnline ? "text-black" : "text-white"
        } w-full`}
      >
        {isOnline ? t("online") : t("offline")}
      </span>
      {/* {isOnline && latency && (
        <span className="text-xs opacity-80">{latency}ms</span>
      )} */}
    </motion.div>
  )
}
